module.exports = __webpack_public_path__ + "img/QRcode.35fad080.png";